import { c, classy } from '@onfido/castor';
import { Input } from '@onfido/castor-react';
import React from 'react';
import { MaybeIcon } from '../../internal';
import { withRef } from '../../utils';
/**
 * `Search` by default uses an `Icon` that requires `Icons` (SVG sprite) to be
 * included in your app.
 *
 * https://github.com/onfido/castor-icons#use-with-plain-code
 *
 * You may also provide any other SVG element via the `icon` prop, but using
 * Castor iconography is recommended.
 */
export const Search = withRef(function Search({ className, icon, style, ...restProps }, ref) {
    return (React.createElement("div", { className: classy(c('search'), className), style: style },
        React.createElement(Input, { ...restProps, ref: ref, type: "search" }),
        React.createElement(MaybeIcon, { icon: icon, name: "search" })));
});
//# sourceMappingURL=search.js.map